module.exports = __webpack_public_path__ + "img/applogo.abd2c1d9.jpg";